import CommonService from '@/_core/service/commonService';
import appConfiguration from '@/plugins/appSettings';
import store from '@/store';

const authMixin = {
  data() {
    return {
      applicationCode: appConfiguration.serverSettings.applicationCode,
      defaultLanguageCode: appConfiguration.defaultConfigurations.language,
      screenLoaded: false,
    };
  },
  async created() {
    await this.getAppProperties();
    const locale = await CommonService.getLocaleData(this.defaultLanguageCode);

    this.$i18n.locale = this.defaultLanguageCode;
    this.$i18n.setLocaleMessage(this.defaultLanguageCode, locale[this.defaultLanguageCode]);
  },
  methods: {
    async getAppProperties() {
      try {
        const fecaProps = await CommonService.getAppProperties(
          appConfiguration.defaultConfigurations.appProperties.feca,
        );

        store.dispatch('userStore/setUserData', {
          fecaProps: fecaProps,
        });
        this.fecaProps = this.deepClone(fecaProps);
      } catch (e) {
        // eslint-disable-next-line
        console.log('error in getAppProperties method', e);
      }
    },
    deepClone(obj) {
      if (obj) {
        return JSON.parse(JSON.stringify(obj));
      }
    },
  },
};

export default authMixin;
